import { Stack, StackProps, styled } from '@mui/material';

import Button from '../../../../../components/Button';
import { hexToRgba } from '../../../../../utils/color';
import { generateClasses } from '../../../../../utils/helper';

export const backgroundClasses = generateClasses('Background', [
  'transparentBackground',
  'backgroundImageContainer',
  'backgroundImageControls',
  'removeBackgroundButton',
]);

export const Root = styled((props: StackProps) => <Stack direction="row" p={2} gap={2} {...props} />)(
  ({ theme }) => ({
    height: '100%',
    borderRadius: theme.spacing(2),
    overflow: 'hidden',
    backgroundColor: '#efefef',
    [`&.${backgroundClasses.transparentBackground}`]: {
      backgroundColor: 'transparent',
    },

    position: 'relative',
    [`& .${backgroundClasses.backgroundImageContainer}`]: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',

      [`& .${backgroundClasses.backgroundImageControls}`]: {
        position: 'absolute',
        bottom: 12,
        left: 12,
      },
    },

    '& > *': {
      flex: 1,
    },
  })
);

export const BackgroundImage = styled('img')(({ theme }) => ({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
}));

export const BackgroundImageControls = styled((props: StackProps) => (
  <Stack direction="row" alignItems="center" p={2} gap={2} {...props} />
))(({ theme }) => ({
  borderRadius: theme.spacing(2),
  backgroundColor: hexToRgba(theme.palette.grey[100], 0.8),
}));

export const BackgroundImageControl = styled(Button)(({ theme }) => ({
  padding: theme.spacing(1),
  minHeight: 'unset',
  [`&.${backgroundClasses.removeBackgroundButton}`]: {
    padding: theme.spacing(2),
  },
}));
